// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '../components/Dashboard.vue'

const routes = [
  { path: '/', component: Dashboard }, // Panel/login interno
  {
    path: '/registro/:stand_id',
    component: () => import('../components/RegistroPublico.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router

